// extracted by mini-css-extract-plugin
export default {"mainContainer":"forgot-password_mainContainer__F5+0q","formContainer":"forgot-password_formContainer__-Iu3e","title":"forgot-password_title__vs9ta"};